import React from 'react';
import { ShieldAlert } from 'lucide-react';
import { useScopeRiskSummary } from '../../../hooks/analytics/useScopeReports.ts';
import { StatCard, WidgetCard } from '../controller/shared.tsx';

/** `scope_risk_summary` — total risks in scope, mapped vs. unmapped, with a delta. */
export const ScopeRiskSummaryCard: React.FC = () => {
  const { data, isLoading, isError, error, dataUpdatedAt, isFetching, refetch } = useScopeRiskSummary();

  return (
    <WidgetCard
      title="Risk Summary"
      description="Risks in scope, mapped vs. unmapped to a control"
      loading={isLoading}
      error={isError ? error : null}
      errorMessage={error?.message ?? 'Failed to load risk summary.'}
      isEmpty={!isLoading && !isError && !data}
      emptyMessage="No risks recorded yet."
      updatedAt={dataUpdatedAt}
      onRefresh={refetch}
      isFetching={isFetching}
    >
      <div className="analytics-kpi-grid gap-3">
        <StatCard
          title="Total Risks"
          value={data?.total ?? 0}
          icon={<ShieldAlert className="h-5 w-5" />}
          color="bg-rose-100 text-rose-600"
          delta={data?.delta ?? undefined}
          deltaSuffix=""
          deltaDigits={0}
        />
        <StatCard title="Mapped" value={data?.mapped_count ?? 0} color="bg-emerald-100 text-emerald-600" />
        <StatCard title="Unmapped" value={data?.unmapped_count ?? 0} color="bg-amber-100 text-amber-600" />
      </div>
    </WidgetCard>
  );
};

export default ScopeRiskSummaryCard;
